export var getBackground = function getBackground() {
  return "var(--ds-surface, #FFFFFF)";
};